import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentQueueService } from  '../../_api/services/document-queue.service'
import { DocumentStatus } from "../../_api/models/document-status.model";
import { LanguageService } from '../../../../shared/services/language.service';
import { custom } from 'devextreme/ui/dialog';
import { DocumentType } from '../../_api/models/document-type.model';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  

  readonly allowedPageSizes = [5, 10, 'all'];
  readonly displayModes = [{ text: "Display Mode 'full'", value: 'full' }, { text: "Display Mode 'compact'", value: 'compact' }];
  displayMode = 'full';
  showPageSizeSelector = true;
  showInfo = true;
  showNavButtons = true;
  saveDialog = null;
  unchanged = true;
  counter = 0;
  docFieldQty = 19;

  @Output() onDocumentSearch = new EventEmitter<any>();
  @Output() onSelectedDocument = new EventEmitter<any>();
  @Output() searchExistingButtonPressed = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();

  @Input() attributeDataSource: any;
  @Input() documentTypes: DocumentType[];
  @Input() documentCategories: any[];

  selectedCodes: any;
  attributeValues: any[];

  selectedLine: any;
  description: any;
  name: any;
  number: any;
  fileName: any;
  thumbnail: any;
  filterData: any;

  documents: any;
  
  documentStatuses: DocumentStatus[];

  docTypeValue: any;
  docStatusValue: any;
  docCategoryValue: any;

  constructor(private documentQueueService: DocumentQueueService, public ls: LanguageService) { }

  ngOnInit(): void {
    this.isLoading.emit(true);
    this.getDocumentQueue().then(() => {})
    this.getDocumentStatuses().then(() =>{})
    this.initSaveDialog();
    this.fileName = '';
    this.unchanged = true;
    this.counter = 0;
    this.isLoading.emit(false);
  }

  async getDocumentQueue(){
    this.documents = await this.documentQueueService.getDocumentQueue().toPromise();
  }

  async getDocumentStatuses() {
     this.documentStatuses = await this.documentQueueService.getStatuses().toPromise();
  }

  async onSelectionChanged(e) {
    if (!this.unchanged) {
      this.getDocumentQueue();
      this.unchanged = true;
    }
    this.counter = 0;
    this.searchExistingButtonPressed.emit(false);
    this.selectedLine = e.data;

    this.onSelectedDocument.emit(this.selectedLine);

    this.thumbnail = '';    
    
    if(this.selectedLine.DocumentFile){
      this.thumbnail = this.selectedLine.DocumentFile.FileThumbSmall;
    }
    else{
      this.thumbnail = '';
    }
  }

  async saveChanges(e) {

  }

  initSaveDialog() {
    this.saveDialog = custom({
      title: this.ls.LNG('Label.Save'),
      messageHtml: "<b>" + this.ls.LNG("Label.Confirm.Save.Unfinnished.SignUp.And.Finnish.Later") + "</b>",
      buttons: [{
        text: this.ls.LNG("Label.Button.Yes"),
        onClick: (e) => {
          return true;
        }
      },
      {
        text: this.ls.LNG("Label.Button.Cancel"),
        onClick: (e) => {
          return false;
        }
      }
      ]
    });
  }

  delete(e){
  }

  setUnchanged(e) {
    this.unchanged = true;
  }

  updateDescription($event: any){
    this.selectedLine.Description = $event.value;
    this.unchanged = false;
  }

  updateName($event: any){
    this.selectedLine.Name = $event.value;
    this.unchanged = false;
  }

  updateNumber($event: any){
    this.selectedLine.Number = $event.value;
    this.unchanged = false;
  }
  onFieldDataChanged(e) {
    this.counter += 1;
    if (this.counter > this.docFieldQty) {
      this.unchanged = false;
    }
  }

  updateDocumentType($event: any) {
    this.selectedLine.DocumentTypeId = $event.value;
    this.unchanged = false;
  }

  updateDocumentCategory($event: any) {
    this.selectedLine.DocumentCategoryId = $event.value;
    this.unchanged = false;
  }

  updateDocumentStatus($event: any) {
    console.log("UpdateDocumentStatus: " + $event);
    this.unchanged = false;
  }
}
